export default __webpack_public_path__ + "static/media/48.8623a0ba.jpeg";